import { objectInformationSectionValidationMap } from './sections/objectInformationSection/validations';
import { projectInformationSectionValidationMap } from './sections/projectInformationSection/validations';

export const hausbankObjectInformationFieldValidation = {
  ...objectInformationSectionValidationMap,
  ...projectInformationSectionValidationMap,
};
